import { useEffect } from 'react'

export default function usePageTitle(title, ...args) {
    useEffect(() => {
        document.title = title + ' - Heliocor Platform'
    }, args)
}
